<template>
  <div class="go-out-list" v-iscroll>
    <ul class="go-out-wrap">
      <li class="list" v-for="(item, index) in outList">
        <div class="bor"></div>
        <span class="time">{{item.time}}</span>
        <span class="thing">{{item.dynamic}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import VIscroll from 'viscroll'
  export default {
    components: { VIscroll },
    props: [
      'outList'
    ],
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters([
      ])
    },
    watch: {
    },
    methods: {
      ...mapActions([
      ]),
      hoverCityOver () {
      },
      hoverCityOut (iner) {
      },
      aab () {
      }
    },
    created () {
      console.log(this.outList)
      setTimeout(() => {
      }, 1000)
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .go-out-list {
    position: relative;
    width: 100%;
    height: calc(100% - 40px);
        background: rgba(0, 0, 0, 0.3);
    overflow: hidden;
    .go-out-wrap {
      width: 100%;
      height: auto;
      margin: 0;
      padding: 15px;
      text-align: left;
      list-style: none;
      .list {
        position: relative;
        width: 100%;
        height: 80px;
        padding-left: 40px;
        font-size: 18px;
        @include clearfix;
        &:after {
          position: absolute;
          left: 12px;
          top: 20px;
          width: 3px;
          height: 80%;
          background: $brand-green;
          content: "";
        }
      }
      .list:last-child:after {
        display: none;
      }
      .bor {
        position: absolute;
        left: 6px;
        top: 6px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        box-shadow: 0 0 0 6px $brand-green;
      }
      .thing {
        float: right;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// go-out-list.vue?08def28f